import { connect } from "react-redux";
import DashboardTraining from './dashboardTraining';
import { bindActionCreators } from "redux";
import {
  getDashboardTrainingDetails,
  postDashboardTrainingData
} from "services/redux/installation/civilCheckList/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
  dashboardTraining: state.civilReducer.dashboardTraining
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getDashboardTrainingDetails,
      documentUploadUrl,
      postDashboardTrainingData
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(DashboardTraining);
